import { render, staticRenderFns } from "./ContentSelect.vue?vue&type=template&id=3637d4fd&scoped=true"
import script from "./ContentSelect.vue?vue&type=script&lang=js"
export * from "./ContentSelect.vue?vue&type=script&lang=js"
import style0 from "./ContentSelect.vue?vue&type=style&index=0&id=3637d4fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637d4fd",
  null
  
)

export default component.exports